/**
 * Fills "Only X items left" and "Delivered before DATE".
 * Re-runs after in-place product/variant switches because those scripts
 * only bind on DOMContentLoaded.
 */
function setDeliveryDate() {
  document.querySelectorAll('#shippingDate').forEach((dateEl) => {
    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + 3);
    if (deliveryDate.getDay() === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
    dateEl.textContent = deliveryDate.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  });
}

function setStockCount() {
  document.querySelectorAll('#stockCount').forEach((stockEl) => {
    const currentVariantUrl = window.location.pathname + window.location.search;
    const key = 'product_stock_' + currentVariantUrl;
    const savedData = localStorage.getItem(key);
    const now = Date.now();
    let stock;

    if (!savedData) {
      stock = Math.floor(Math.random() * 10) + 3;
      localStorage.setItem(key, JSON.stringify({ count: stock, time: now }));
    } else {
      try {
        const data = JSON.parse(savedData);
        stock = data.count;
        if (now - data.time > 10 * 60 * 1000) {
          stock = Math.max(3, stock - 1);
          localStorage.setItem(key, JSON.stringify({ count: stock, time: now }));
        }
      } catch (_) {
        stock = Math.floor(Math.random() * 10) + 3;
      }
    }

    stockEl.textContent = stock;
  });
}

function initProductIndicators() {
  setDeliveryDate();
  setStockCount();
}

function bindProductIndicators() {
  if (window.__productIndicatorsBound) return;
  window.__productIndicatorsBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductIndicators);
  } else {
    initProductIndicators();
  }

  document.addEventListener('variant:change', () => setTimeout(initProductIndicators, 50), true);
  document.addEventListener('product:rerender', () => setTimeout(initProductIndicators, 50), true);

  const main = document.getElementById('main');
  if (main && window.MutationObserver) {
    const observer = new MutationObserver(() => {
      const stockEl = document.getElementById('stockCount');
      const dateEl = document.getElementById('shippingDate');
      if ((stockEl && !stockEl.textContent.trim()) || (dateEl && !dateEl.textContent.trim())) {
        initProductIndicators();
      }
    });
    observer.observe(main, { childList: true, subtree: true });
  }
}

bindProductIndicators();
window.initProductIndicators = initProductIndicators;
window.setDeliveryDate = setDeliveryDate;
window.setStockCount = setStockCount;
